import axios from "../index"

// 接口基础路径
const rootApi = '/api_v2/checkProject'

/** 根据id获取检验计划 */
export const getCheckProjectVo = (checkProjectId) => {
  return axios.get(`${rootApi}/vo/${checkProjectId}`)
}

/** 根据id获取检验方案克隆model */
export const getCloneModel = (projectTemplateId) => {
  return axios.get(`${rootApi}/${projectTemplateId}/cloneData`)
}

/** 创建检验方案 */
export const createInspectProject = (params) => {
  return axios.post(`${rootApi}/create`, params , {dataType: 'json'})
}